import Router from 'next/router';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { searchAPIs } from 'apis/services';
import { paths } from 'constants/endPoint';
import { ActionTypeEnum } from 'redux/ActionTypeEnum';
import { loadingAction } from 'redux/settings/action';
import { decodeQueryStrings } from 'utility/decodeURL';

import { filterActionSuccess } from './action';

//getting filter
function* filterRequest({ payload, meta }) {
	try {
		// eslint-disable-next-line no-unused-vars
		const { app_keepa, sponsor_id, ...rest } = payload;
		yield put(loadingAction({ backdrop: true }));

		const response = yield call(searchAPIs.filterers, rest);

		yield put(filterActionSuccess(response.data?.Content));

		yield put(loadingAction({ backdrop: false }));

		if (meta?.isRouter) {
			Router.push(
				{
					pathname: `${paths['/search']}`,
					query: decodeQueryStrings({ ...meta?.parsLocation }),
				},
				undefined,
				{
					shallow: true,
				},
			);

			meta?.sst?.(meta?.parsLocation);
			meta?.sfs?.(meta?.parsLocation);
		}
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

export default function* searchSaga() {
	yield all([takeLatest(ActionTypeEnum.filter_request, filterRequest)]);
}
